import { User } from '@types'

type AccountData = User['accountData']

const hasValue = (value?: string | number) => String(value || '').trim().length > 0

export const hasCompletePaymentProfile = (accountData?: AccountData) =>
  hasValue(accountData?.bankName) &&
  hasValue(accountData?.accountType) &&
  hasValue(accountData?.accountNumber) &&
  hasValue(accountData?.accountDocument) &&
  hasValue(accountData?.accountDocumentLink) &&
  hasValue(accountData?.physicalAddress) &&
  hasValue(accountData?.rutDocument)
